/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect } from 'react'
import { Withdrawal } from 'src/core/models'
import { useTranslation } from 'next-i18next'
import { CheckOutlined } from '@ant-design/icons'
import { Button, Popconfirm, Tooltip } from 'antd'
import { showNotification } from 'src/core/helpers'
import { useAppDispatch, useAppSelector } from 'src/app/hooks'
import {
  resetValidateWithdrawalState,
  validateWithdrawalSelector,
  withdrawalsSelector,
  validateWithdrawal,
} from 'src/features'

const WithdrawalValidateButton: React.FC<{ withdrawal: Withdrawal }> = ({ withdrawal }) => {
  const { t } = useTranslation()
  const dispatch = useAppDispatch()
  const { data: bigList } = useAppSelector(withdrawalsSelector)
  const isDisabled = ['paid', 'canceled'].includes(withdrawal.status)
  const {
    loading: loadingValidation,
    success: sucessValidation,
    error: errorValidation,
    currenctWithdrawal
  } = useAppSelector(validateWithdrawalSelector)

  const tooltip = {
    pending: { label: t('Withdrawals.Validate'), color: 'blue' },
    paid: { label: t('Withdrawals.Validated'), color: 'black' },
    canceled: { label: t('Withdrawals.Cancelled'), color: 'black' },
  }[withdrawal.status]

  useEffect(() => {
    const isValidWithdrawal = currenctWithdrawal === withdrawal.id
    if (sucessValidation && isValidWithdrawal) {
      showNotification('success', t('Withdrawals.Success'))
      dispatch(resetValidateWithdrawalState())
    }
    if (errorValidation && isValidWithdrawal) {
      showNotification('info', t('Validate.Error'))
      dispatch(resetValidateWithdrawalState())
    }
  }, [sucessValidation, errorValidation, currenctWithdrawal])


  const buttonContent = (
    <Tooltip title={tooltip.label} color={tooltip.color}>
      <Button
        type='ghost'
        size='middle'
        shape='circle'
        loading={loadingValidation && currenctWithdrawal === withdrawal.id}
        icon={<CheckOutlined />}
        disabled={isDisabled}
        className={`radius-100 ml-2`}
      />
    </Tooltip>
  )

  return <>
    {isDisabled ? <>{buttonContent}</> : <Popconfirm
      title={t('Withdrawals.SureValidate')}
      onConfirm={() => dispatch(validateWithdrawal(withdrawal.id, bigList))}
      okText={t('general.Yes')}
      placement='bottom'
      cancelText={t('general.Cancel')}
    >
      {buttonContent}
    </Popconfirm>}
  </>
}

export default WithdrawalValidateButton
